module.exports = __webpack_public_path__ + "img/loading01.439ea920.png";